<template>
  <a-drawer
    width="500px"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="客户名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入"/>
      </a-form-model-item>
<!--      <a-form-model-item label="客户编号" prop="number">-->
<!--        <a-input v-model="form.number" placeholder="请输入"/>-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { customInfo, customAdd, customEdit } from '@/api/pages/custom'

export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单
      form: {
        id: 0,
        name: '',
        number: ''
      },
      open: false,
      rules: {
        name: [{ required: true, message: '客户名称不能为空', trigger: ['blur', 'change'] }, { validator: this.validateName, trigger: ['blur', 'change'] }],
        number: [{ required: true, message: '客户编号不能为空', trigger: ['blur', 'change'] }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    validateName (rule, value, callback) {
      if (!/^(?=.*[0-9])(?:[a-zA-Z0-9]+|[0-9]+)$/.test(value)) {
        callback(new Error('请输入（字母+数字）或纯数字'))
      } else {
        callback()
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: 0,
        name: '',
        number: ''
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const configId = row ? row.id : ids
      customInfo({ id: configId }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            customEdit(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            customAdd(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
